import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    dropOffActivePage: {},
    orderID: null,
    transactionBySerialNumber: {},
    saveBillReferenceDropOffResponse: {},
    billDropOffReferences: "",
}

const DropOffSlice = createSlice({
    name: "dropOff",
    initialState,
    reducers: {
        setDropOffActivePage: (state, action) => {
            state.dropOffActivePage = action.payload;
        },
        setOrderID: (state, action) => {
            state.orderID = action.payload;
        },
        setTransactionBySerialNumber: (state, action) => {
            state.transactionBySerialNumber = action.payload
        },
        setSaveBillReferenceDropOffResponse: (state, action) => {
            const { data, status } = action.payload;
            state.saveBillReferenceDropOffResponse = { data, status };
        },
        setBillDropOffReferences: (state, action) => {
            state.billDropOffReferences = action.payload; 
          },
        resetDropOffResponse: (state) => {
            state.orderID = null;
            state.transactionBySerialNumber = {}; 
            state.saveBillReferenceDropOffResponse = {}; 
            state.billDropOffReferences = ""; 
        },
    }
})

export const { setDropOffActivePage, setOrderID, setTransactionBySerialNumber, setSaveBillReferenceDropOffResponse, setBillDropOffReferences, resetDropOffResponse } = DropOffSlice.actions;
export default DropOffSlice.reducer;
